import { createSlice } from '@reduxjs/toolkit'

export const filialSlice = createSlice({
    name: 'filial',
    initialState: {
      filial: [],
      filialIndividual: []
    },
    reducers: {
      addFilial: (state, action) => {
        state.filial = action.payload
      },
      addFilialIndividual: (state, action) => {
        state.filialIndividual = action.payload
      },
    },
});

export const { addFilial, addFilialIndividual } = filialSlice.actions;
export default filialSlice.reducer;